import type { MessagePayload } from 'firebase/messaging'
import { CategoriaNotificacaoType } from '_metronic/helpers'

export type MensagemPush = {
  id?: number
  titulo: string
  texto?: string
  categoria?: CategoriaNotificacaoType
}

const CATEGORIAS = Object.values(CategoriaNotificacaoType) as string[]

/**
 * Extrai a notificação de uma mensagem FCM. O backend manda só `data` (`titulo`, `texto`,
 * `notificacaoId`, `categoria`) — o bloco `notification` faria o SDK exibir uma notificação
 * sozinho, além da montada pelo service worker. O fallback para `notification` cobre mensagens
 * enviadas antes dessa mudança no backend.
 */
export const lerMensagemPush = (payload: MessagePayload): MensagemPush | undefined => {
  const data = payload.data ?? {}

  const titulo = data.titulo ?? payload.notification?.title
  if (!titulo) return undefined

  const id = Number(data.notificacaoId)

  return {
    id: data.notificacaoId && !Number.isNaN(id) ? id : undefined,
    titulo,
    texto: data.texto ?? payload.notification?.body,
    categoria: CATEGORIAS.includes(data.categoria)
      ? (data.categoria as CategoriaNotificacaoType)
      : undefined,
  }
}
